module.exports = __webpack_public_path__ + "static/media/cloudOnlyAccessIcon.7de96cc4.svg";